import React from "react";

import { useNavigateToLink } from "../../../components/react/link";
import { useNotificationConfiguration } from "../../../queries/notifications";
import { NOTIFICATIONS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const NotificationsNamedBreadcrumb: React.FC<{
	id: string;
}> = ({ id }) => {
	const link = useNavigateToLink(NOTIFICATIONS_PATH, {
		params: { id },
		search: ["timeRange", "timestamp", "detachedFilters"],
	});
	const { isLoading, error, data: notification } = useNotificationConfiguration(id);

	if (isLoading) {
		return <BreadcrumbLayout label="" />;
	}

	if (error || notification == null) {
		return <BreadcrumbLayout label="Notification not found" />;
	}

	return <BreadcrumbLayout label={notification.name} to={link} />;
};
